"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketEventManager = void 0;
const conversation_agent_events_1 = require("../../../common/constants/conversation-agent-events");
/**
 * Static helper class for managing WebSocket event listeners
 */
class WebSocketEventManager {
    /**
     * Setup all WebSocket listeners for conversation agent events
     */
    static setupListeners(wsService, listeners, eventHandlers) {
        // Clean up existing listeners first
        WebSocketEventManager.cleanupListeners(listeners);
        console.log('🎧 [WebSocketEventManager] Setting up WebSocket listeners');
        const unsubscribeSessionStarted = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleSessionStarted(wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.CONVERSATION_AGENT_STARTED);
        const unsubscribeAgentError = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleAgentError(wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.CONVERSATION_AGENT_ERROR);
        const unsubscribeSessionEnded = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleSessionEnded(wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.CONVERSATION_AGENT_ENDED);
        const unsubscribeUserTranscription = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleUserTranscription(wsResponse);
        }, 'user_transcription');
        const unsubscribeAgentStatus = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleAgentStatus(wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.AGENT_STATUS);
        const unsubscribeContextUpdated = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleContextUpdated(wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.AGENT_CONTEXT_UPDATED);
        const unsubscribeAgentConfigured = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleAgentConfigured(wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.AGENT_CONFIGURED);
        // Listen for speech detection events
        const unsubscribePartialTranscription = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handlePartialTranscription(wsResponse);
        }, 'user_transcription_partial');
        const unsubscribeAudioResponse = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleAudioResponse(wsResponse);
        }, 'agent_audio_response');
        const unsubscribeTextResponse = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleTextResponse(wsResponse);
        }, 'agent_text_response');
        const unsubscribeStopRecording = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleStopRecording(wsResponse);
        }, 'stop_recording');
        const unsubscribeConversationMessage = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            eventHandlers.handleConversationMessage(wsResponse);
        }, 'conversation_message');
        // Listen for session timeout
        const unsubscribeSessionTimeout = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            var _a;
            (_a = eventHandlers.handleSessionTimeout) === null || _a === void 0 ? void 0 : _a.call(eventHandlers, wsResponse);
        }, conversation_agent_events_1.CONVERSATION_AGENT_EVENTS.SESSION_TIMEOUT);
        // Listen for STT session stop (when transcription goes to LLM)
        const unsubscribeSTTSessionStop = wsService.listenForMessage('conversation_agent', (wsResponse) => {
            var _a;
            (_a = eventHandlers.handleSTTSessionStop) === null || _a === void 0 ? void 0 : _a.call(eventHandlers, wsResponse);
        }, 'stt_session_stop');
        // Store all unsubscribe functions for cleanup
        listeners.set('sessionStarted', unsubscribeSessionStarted);
        listeners.set('agentError', unsubscribeAgentError);
        listeners.set('sessionEnded', unsubscribeSessionEnded);
        listeners.set('userTranscription', unsubscribeUserTranscription);
        listeners.set('agentStatus', unsubscribeAgentStatus);
        listeners.set('contextUpdated', unsubscribeContextUpdated);
        listeners.set('agentConfigured', unsubscribeAgentConfigured);
        listeners.set('partialTranscription', unsubscribePartialTranscription);
        listeners.set('audioResponse', unsubscribeAudioResponse);
        listeners.set('textResponse', unsubscribeTextResponse);
        listeners.set('stopRecording', unsubscribeStopRecording);
        listeners.set('conversationMessage', unsubscribeConversationMessage);
        listeners.set('sessionTimeout', unsubscribeSessionTimeout);
        listeners.set('sttSessionStop', unsubscribeSTTSessionStop);
    }
    /**
     * Cleanup all WebSocket listeners
     */
    static cleanupListeners(listeners) {
        listeners.forEach((unsubscribe) => {
            unsubscribe();
        });
        listeners.clear();
    }
    /**
     * Setup listener for a custom WebSocket event
     */
    static listenForCustomEvent(wsService, eventName, callback) {
        return wsService.listenForMessage('conversation_agent', callback, eventName);
    }
}
exports.WebSocketEventManager = WebSocketEventManager;
